__turbopack_context__.v({
  "captionText": "c8IByW_captionText",
  "col": "c8IByW_col",
  "figure": "c8IByW_figure",
  "grid1Col": "c8IByW_grid1Col",
  "grid2Col": "c8IByW_grid2Col",
  "imagesRow": "c8IByW_imagesRow",
  "paragraph": "c8IByW_paragraph",
  "storyBlock": "c8IByW_storyBlock",
  "subtitle": "c8IByW_subtitle",
  "title": "c8IByW_title",
});
